import React from "react";
import { graphql } from "gatsby";
import Layout from "containers/Layout";
import SiteHead from "containers/SiteHead";
import HeroBgImage from "../img/hero-bg.png";
import { Helmet } from "react-helmet";
import { companyLink } from "components/Links.mjs";
import { Link } from "components/Router";
// Importing related styles
import "../sass/sp-holdings.scss";

const description = "S&P 500 Holdings";

const CompanyRow = (props) => {
  const { company, index, symbol: symbolObject, indexRank } = props;
  const { sector, employees } = company || {};
  const { price, company_name, symbol: tickerSymbol } = index;
  const { exchange, symbol, name } = symbolObject || {};

  return (
    <tr>
      <td>{indexRank}</td>
      <td>
        { exchange && symbol ?
          <Link to={companyLink(exchange, symbol)} className="link-element">
            {name}
          </Link>
          :
          <>{company_name}</>
        }
      </td>
      <td>
        { exchange && symbol ?
          <Link to={companyLink(exchange, symbol)} className="link-element">
            {symbol}
          </Link>
          :
          <>{tickerSymbol}</>
        }
      </td>
      <td>{sector}</td>
      <td>{price}</td>
      <td>{employees}</td>
    </tr>
  );
};

const Holdings = (props) => {
  const {
    data: {
      sp500Companies: {
        sp500Companies
      },
    },
  } = props;
  const filteredCompanies = sp500Companies.filter((data) => data?.symbol?.exchange && data?.symbol?.symbol);
  return (
    <>
      <SiteHead
        title="EarningsCall · S&P 500 Holdings"
        description={description}
        pageProps={props}
      />
      <Helmet>
        <link rel="preload" as="image" href={HeroBgImage} />
      </Helmet>
      <section className="common-hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="title">S&P 500 Holdings</h1>
            <p className="text">
              The Standard & Poor's 500 (S&P 500) is a stock market index that tracks the performance of 500 large companies.
              The companies you see below are listed in descending weighted order.
            </p>
          </div>
        </div>
      </section>
      <section className="holdings-table-section">
        <div className="container">
          <div className="table-responsive">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Company</th>
                  <th scope="col">Symbol</th>
                  <th scope="col">Sector</th>
                  <th scope="col">Stock Price</th>
                  <th scope="col">Employees</th>
                </tr>
              </thead>
              <tbody>
                { filteredCompanies.map((item, index) => <CompanyRow key={index + 1} indexRank={index + 1} {...item} />) }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};
const HoldingsExport = (props) => (
  <Layout {...props}>
    <Holdings {...props} />
  </Layout>
);
export default HoldingsExport;

export const pageQuery = graphql`
  query Sp500CompaniesQuery {
    sp500Companies {
      sp500Companies {
        company {
          sector
          employees
          industry
          name
          is_approved
        }
        index {
          price
          symbol
          weight
          company_name
        }
        symbol {
          exchange
          name
          symbol
        }
      }
    }
  }
`;
